import PubSub from "./pubsub.js";

if (!customElements.get("panel-switch")) {
  class PanelSwitch extends HTMLElement {
    constructor() {
      super();
      this.pubsub = PubSub;
      this.btn = this.querySelector('[name="panel-switch-button"]');
      this.panel = this.getAttribute("for");
    }

    handleClick = (e) => {
      e.preventDefault();
      this.pubsub.pub("panel-switch", { target: e.target.dataset.target });
    };

    handleSwitch = (data) => {
      if (data.target === this.panel) {
        this.classList.remove("hidden");
        this.classList.add("block");
      } else {
        this.classList.remove("block");
        this.classList.add("hidden");
      }
    };

    connectedCallback() {
      this.btn.addEventListener("click", this.handleClick.bind(this), false);
      this.pubsub.sub("panel-switch", this.handleSwitch.bind(this));
    }
    disconnectedCallback() {}
  }

  customElements.define("panel-switch", PanelSwitch);
}
